// CANONICAL VERIFIED NUMBERS, single source of truth for stats that appear
// in UI chrome (Deal-Checker banners, CTAs, funnel copy). If a number changes,
// change it HERE and grep prose (cards/blog/kit/state data) for the old value,
// AUDIT.md lists every surface each claim appears on.
//
// Verification (2026-07-13, IRS.gov fetched directly):
// - 30D new-EV credit (up to $7,500): "not available for vehicles acquired
//   after Sept. 30, 2025" (OBBBA).
// - 25E used-EV credit (up to $4,000): same termination date.
// - 30C home-charger credit (30% up to $1,000): available Jan 1 2023 –
//   June 30 2026 only. Installed on or before that date => still claimable
//   on that year's return (IRS Form 8911).

export const FED_NEW_CREDIT_LABEL = '$7,500';
export const FED_USED_CREDIT_LABEL = '$4,000';
export const FED_CREDIT_END = 'September 30, 2025';
export const CHARGER_CREDIT_END = 'June 30, 2026';

// Consumer Reports: dealer add-ons clocked at $4,000+ on a single sale.
export const JUNK_FEE_TOTAL_LABEL = '$4,000+';

// NTSB/insurance data cited on card #1: ~25 fires per 100k EVs sold
// (vs ~1,530 gas / ~3,475 hybrid).
export const EV_FIRES_PER_100K = 25;

// FHWA: average American drives ~37 miles/day (card #29 / range content).
export const AVG_DAILY_MILES = 37;

// Gas and hybrid fire rates from the same card #1 source.
export const GAS_FIRES_PER_100K_LABEL = '1,530';

// DOE AFDC live station counts, mid-2026 (card #14): 81,000+ public charging
// locations, 250,000+ public ports.
export const PUBLIC_CHARGING_LOCATIONS_K = 81;

// Card #3: many older Teslas have hit 200,000 to 400,000 miles on the original pack.
export const ORIGINAL_PACK_MILES_K = 400;
